export default __webpack_public_path__ + "static/media/Front-Apartment-Dbayeh-Marina.19619967.jpg";